import { Folder, Bath, ShowerHead, CookingPot, Sofa, BedDouble, WashingMachine, Sprout, Car, Warehouse, LampDesk, Baby, Dog, Trees, Hammer, Heart } from "lucide-react";
import { COLORS } from "@/lib/api";

export const LIST_ICONS = {
  folder: { Icon: Folder, label: "Folder" },
  bath: { Icon: Bath, label: "Bathroom" },
  shower: { Icon: ShowerHead, label: "Shower" },
  oven: { Icon: CookingPot, label: "Kitchen" },
  sofa: { Icon: Sofa, label: "Living room" },
  bed: { Icon: BedDouble, label: "Bedroom" },
  laundry: { Icon: WashingMachine, label: "Laundry" },
  plant: { Icon: Sprout, label: "Plants" },
  car: { Icon: Car, label: "Car" },
  garage: { Icon: Warehouse, label: "Garage" },
  desk: { Icon: LampDesk, label: "Study" },
  baby: { Icon: Baby, label: "Kids" },
  dog: { Icon: Dog, label: "Pets" },
  garden: { Icon: Trees, label: "Garden" },
  tools: { Icon: Hammer, label: "Repairs" },
  heart: { Icon: Heart, label: "Personal" },
};

const R = 20;
const C = 2 * Math.PI * R;

export const ProgressRing = ({ list, testId }) => {
  const color = COLORS[list.color] || COLORS.terracotta;
  const { Icon } = LIST_ICONS[list.icon] || LIST_ICONS.folder;
  const total = list.items.length;
  const pct = total ? list.items.filter((i) => i.done).length / total : 0;
  return (
    <span className="relative h-11 w-11 shrink-0 inline-flex items-center justify-center" data-testid={testId} data-progress={Math.round(pct * 100)}>
      <svg viewBox="0 0 44 44" className="absolute inset-0 -rotate-90" aria-hidden="true">
        <circle cx="22" cy="22" r={R} fill="none" strokeWidth="3" className="stroke-t-surface" />
        <circle cx="22" cy="22" r={R} fill="none" strokeWidth="3" stroke={color} strokeLinecap="round"
          strokeDasharray={C} strokeDashoffset={C * (1 - pct)} className="transition-[stroke-dashoffset] duration-500" />
      </svg>
      <span className="h-8 w-8 rounded-full flex items-center justify-center" style={{ backgroundColor: color }}>
        <Icon className="h-4 w-4 text-white" />
      </span>
    </span>
  );
};
